import { useState } from 'react';
import { assetUrl } from '../lib/images';

/**
 * A responsive WebP from public/img/art, e.g. base "img/art/capitalism-scene" with
 * widths [640, 1100] uses capitalism-scene-640.webp and capitalism-scene-1100.webp.
 * The browser downloads only the size it needs. Hides itself if the file is missing.
 */
export default function ArtImage({ base, widths, sizes, aspect = 1, alt = '', className = '' }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  const largest = widths[widths.length - 1];
  return (
    <img
      className={className}
      src={assetUrl(`${base}-${largest}.webp`)}
      srcSet={widths.map((w) => `${assetUrl(`${base}-${w}.webp`)} ${w}w`).join(', ')}
      sizes={sizes}
      width={largest}
      height={Math.round(largest / aspect)}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
